import React, { useEffect } from 'react';
import { TrevorComponent } from '@trevor/ui-components';
import { useDatasourceId } from '@/hooks';
import AjaxSpinner from '@/components/AjaxSpinner';
import styled from 'styled-components';
import { UUID } from '@/types';
import { PLAN_NAMES } from '@/features/credits/components/utils';
import {
  useAddDatasourceToSubscriptionMutation,
  useGetAvailableCreditSubscriptionsQuery,
} from '@/features/subscription/apiSlice';
import {
  AddSubscriptionButton,
  Loading,
  Separator,
  SubscriptionItem,
} from './styled-components';

const _AddToSubscription: TrevorComponent<{ onSuccess: F0 }> = ({
  className,
  onSuccess,
}) => {
  const datasourceId = useDatasourceId();
  const { data: availableSubscriptions, isLoading } =
    useGetAvailableCreditSubscriptionsQuery(datasourceId);

  const [addDatasource, result] = useAddDatasourceToSubscriptionMutation();

  useEffect(() => {
    if (result.isSuccess) {
      onSuccess();
    }
  }, [result]);

  const addToSubscription = (subscriptionId: UUID) => {
    addDatasource({ datasourceId, subscriptionId });
  };

  if (isLoading || result.isLoading) {
    return (
      <Loading className={className}>
        <AjaxSpinner small />
      </Loading>
    );
  }

  if (availableSubscriptions?.length === 0) {
    return (
      <div className={className}>
        <span>You have no existing subscriptions</span>
      </div>
    );
  }

  const subscriptionList = availableSubscriptions?.map((subscription, i) => {
    return (
      <div key={i}>
        <SubscriptionItem>
          <span>
            {PLAN_NAMES[subscription.stripePlan]} -{' '}
            {subscription.trevorUserEmail}
          </span>
          <AddSubscriptionButton
            onClick={() => addToSubscription(subscription.id)}
          >
            Add to this subscription
          </AddSubscriptionButton>
        </SubscriptionItem>
        <Separator />
      </div>
    );
  });

  return <div className={className}>{subscriptionList}</div>;
};

export const AddToSubscription = styled(_AddToSubscription)`
  width: 400px;
  font-size: 13px;
  margin-left: 22px;
  margin-bottom: 20px;
`;
